module.exports = __webpack_public_path__ + "img/logo-light.a65b1e9a.png";